import { useContext } from "react";
import { IonCard, IonCardContent, IonSelect, IonSelectOption, IonTitle } from "@ionic/react";
import { ActionType } from "../../state/GlobalState";
import { formatLogMessage, LogLevel } from "../../services/LogService";
import { AppContext } from "../../state/AppContextProvider";

const LogItemView = ({ log }) => {

  const levelClass = {
    0: "text-blue-500",
    1: "text-gray-300",
    2: "text-yellow-600",
    3: "text-red-700",
    4: "text-purple-700",
  }

  let detail = '';

  try {
    detail = JSON.stringify(log.detail, null, 2);
  } catch( e ) {
    detail = 'Unable to stringfy log detail';
  }

  return (
    <li className={levelClass[log.level]}>
      {formatLogMessage(log)}
      {log.detail && <pre className="ml-1">{detail}</pre>}
    </li>);
}

export const LogsCard = ({ logs }) => {

  const { state, dispatch } = useContext(AppContext);

  const setLogLevel = (e) => {
    dispatch({ type: ActionType.SetLogLevel, payload: e.detail.value });
  }

  return (
    <IonCard>
      <IonTitle>Logs</IonTitle>
      <IonSelect className=" border-b-2" value={state.logLevel} placeholder="Select One" onIonChange={setLogLevel}>
        {Object.values(LogLevel).filter((level) => (isNaN(+level))).map((level, idx) => (
          <IonSelectOption key={idx} value={idx}>{level}</IonSelectOption>
        ))}
      </IonSelect>
      <IonCardContent className="coding scrollable scroll-x scroll-y inverse-toggle px-5 shadow-lg text-gray-100 text-sm font-mono subpixel-antialiased 
              bg-gray-800  pb-6 leading-normal" style={{ maxHeight: "65vh" }}>
        <ul className="">
          {
            logs.map((log, idx) => (<LogItemView key={idx} log={log} />))
          }
        </ul>
      </IonCardContent>
    </IonCard>
  );
};
